var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclusivePromotions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 59,
    rx: 12,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5248 19.7949C29.5687 19.7064 29.6364 19.6318 29.7203 19.5797C29.8042 19.5276 29.9011 19.5 29.9998 19.5C30.0986 19.5 30.1955 19.5276 30.2794 19.5797C30.3633 19.6318 30.431 19.7064 30.4748 19.7949L32.7848 24.4739C32.937 24.7819 33.1617 25.0483 33.4395 25.2503C33.7173 25.4524 34.04 25.584 34.3798 25.6339L39.5458 26.3899C39.6437 26.4041 39.7357 26.4454 39.8113 26.5091C39.887 26.5728 39.9433 26.6564 39.9739 26.7505C40.0045 26.8446 40.0081 26.9453 39.9844 27.0413C39.9607 27.1374 39.9107 27.2248 39.8398 27.2939L36.1038 30.9319C35.8575 31.172 35.6731 31.4684 35.5667 31.7955C35.4602 32.1227 35.4349 32.4708 35.4928 32.8099L36.3748 37.9499C36.3921 38.0477 36.3816 38.1485 36.3443 38.2406C36.3071 38.3327 36.2448 38.4125 36.1644 38.4709C36.084 38.5293 35.9888 38.5639 35.8897 38.5708C35.7906 38.5777 35.6915 38.5566 35.6038 38.5099L30.9858 36.0819C30.6816 35.9221 30.343 35.8386 29.9993 35.8386C29.6557 35.8386 29.3171 35.9221 29.0128 36.0819L24.3958 38.5099C24.3082 38.5563 24.2092 38.5772 24.1103 38.5701C24.0114 38.5631 23.9164 38.5285 23.8361 38.4701C23.7559 38.4118 23.6937 38.3321 23.6565 38.2401C23.6193 38.1482 23.6087 38.0476 23.6258 37.9499L24.5068 32.8109C24.565 32.4716 24.5398 32.1233 24.4334 31.7959C24.3269 31.4686 24.1425 31.172 23.8958 30.9319L20.1598 27.2949C20.0884 27.2259 20.0378 27.1383 20.0138 27.042C19.9898 26.9456 19.9933 26.8445 20.0239 26.7501C20.0546 26.6557 20.1111 26.5717 20.1871 26.5079C20.2631 26.444 20.3556 26.4028 20.4538 26.3889L25.6188 25.6339C25.9591 25.5844 26.2822 25.453 26.5604 25.2509C26.8386 25.0488 27.0636 24.7822 27.2158 24.4739L29.5248 19.7949Z",
    stroke: "url(#paint0_linear_830_10627)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_830_10627",
    x1: 19.998,
    y1: 29.036,
    x2: 39.9998,
    y2: 29.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusivePromotions);
export default __webpack_public_path__ + "static/media/Exclusive Promotions.8728fd7616e78ca397a76574623ee607.svg";
export { ForwardRef as ReactComponent };